import type { LeaguePortfolioSeatPublic } from "@softmax/observatory-client/types";

import { getActualViewer } from "@/data/viewer";

import type { PlayApi } from "./play-api";
export function createPlayParticipationReader({
  signal,
  api,
}: {
  signal?: AbortSignal | undefined;
  api: PlayApi;
}) {
  async function hasParticipation({
    leagueId,
    seats,
  }: {
    leagueId: string;
    seats: LeaguePortfolioSeatPublic[];
  }): Promise<boolean> {
    if (seats.some((seat) => seat.league_id === leagueId)) return true;

    const [requests, submissions] = await Promise.all([
      api.myExperienceRequests({
        leagueId,
      }),
      api.mySubmissions({
        leagueId,
      }),
    ]);

    if (requests === null || submissions === null)
      throw new Error("League participation is unavailable");

    return requests.entries.length > 0 || submissions.length > 0;
  }
  const canEnter = async (leagueId: string): Promise<boolean> => {
    if (!(await getActualViewer({ signal }))) return false;

    const seats = await api.portfolio();

    if (seats === null) throw new Error("League membership is unavailable");

    return hasParticipation({
      leagueId,
      seats,
    });
  };
  return { hasParticipation, canEnter };
}
